// Create post for product maintenance (add)
import $ from 'jquery'
import { createAlert } from '../../dom/window'
import _, { add } from 'lodash'
import config from '../../store/_config'
import { axiosInstance as axios, handleAxiosErrors, breakListIntoChunks } from '_utils'
import {
  convertDeleteThreePlCustomerDetailToPost,
  convertThreeEditPlCustomerDetailToPost,
  convertThreePlCustomerDetailToPost,
} from '../../selectors/converterSelectors'
import { convertThreePlCustomerListingToAReadableFormat } from '../../selectors/productSelectors'
import { buildRequestProductListParams } from '../../../main/selectors/defaultSelectors'
import { param } from '../../_utils'
import { updateActive3PLCustomerName } from '../../actions/supplierActions'

export const toggleLoading = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_THREE_PL_CUSTOMER_LOADING',
      key: key,
      value: value,
    })
  }
}

export const updateThreePlCustomerList = (list) => {
  return {
    type: 'UPDATE_THREE_PL_CUSTOMER_LIST',
    list: list,
  }
}

export const updateThreePlCustomerFullList = (list) => {
  return {
    type: 'UPDATE_THREE_PL_CUSTOMER_FULL_LIST',
    list: list,
  }
}

export const toggleDeActivateCustomerModal = (toggle) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_THREE_PL_CUSTOMER_DEACTIVATE_MODAL',
      value: toggle,
    })
  }
}

export const confirmDeActivateCustomerDetail = (data) => {
  return (dispatch, getState) => {
    const store = getState()
    const params = store?.threePlCustomers?.confirmationModalData
    dispatch(loadDetailDeActivateCustomerModal({}))
    dispatch(toggleDeActivateCustomerModal(false))
    dispatch(activateThreePlCustomer(params))
  }
}

export const loadDetailDeActivateCustomerModal = (params) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_DEACTIVATE_CONFIRMATION_MODAL_DATA',
      value: params,
    })
    dispatch(toggleDeActivateCustomerModal(true))
  }
}

export const getDefaultThreePlCustomerDetails = () => {
  return {
    threePlId: '',
    customerName: '',
    CustomerPhone: '',
    CustomerEmail: '',
    CreditTerms: '',
    preferedDeliveryTime: '',
    preferedDeliveryDay: '',
    deliveryNotes: '',
    Address: '',
    UnitNumber: '',
    StreetNumber: '',
    Suburb: '',
    State: '',
    PostalCode: '',
    Country: '',
    LiquorLicenseNumber: '',
    isResidential: false,
    licenceNumber: '',
    isGlobalDatabase: false,
    status: '1',
  }
}

// Actions for Customer Modal on Search 3pl Customer Modal
export const toggleAddCustomerModal = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_3pl_ADD_CUSTOMER_MODAL',
      value: value,
    })
  }
}

export const showAddCustomerModal = () => {
  return async (dispatch, getState) => {
    dispatch(emptyCreateCustomerDetails())
    dispatch(toggleAddCustomerModal(true))
  }
}

export const hideAddCustomerModal = () => {
  return async (dispatch, getState) => {
    dispatch(toggleAddCustomerModal(false))
  }
}

//////////////////////////////

export const toggleModal = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_THREE_PL_MODAL',
      value: value,
    })
  }
}

export const toggleEditModal = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_THREE_PL_EDIT_MODAL',
      value: value,
    })
  }
}

export const changeThreePlCustomerAddDetails = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_THREE_PL_DETAIL',
      key: key,
      value: value,
    })
  }
}

export const changeThreePlCustomerEditDetails = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_THREE_PL_EDIT_DETAIL',
      key: key,
      value: value,
    })
  }
}

export const emptyCreateCustomerDetails = () => {
  return (dispatch, getState) => {
    dispatch({
      type: 'EMPTY_THREE_PL_EDIT_DETAIL',
    })
  }
}

export const showModal = () => {
  return async (dispatch, getState) => {
    dispatch(emptyCreateCustomerDetails())
    dispatch(toggleModal(true))
  }
}

export const showEditModal = () => {
  return async (dispatch, getState) => {
    dispatch(toggleEditModal(true))
  }
}

export const hideEditModal = () => {
  return async (dispatch, getState) => {
    dispatch(toggleEditModal(true))
  }
}

export const hideModal = () => {
  return async (dispatch, getState) => {
    dispatch(toggleModal(false))
  }
}

export const postThreePlCustomer = (postData, callback = null) => {
  return async (dispatch, getState) => {
    dispatch(toggleLoading('form', true))

    //dispatch(toggleLoading(false));
    let setActive = postData?.setActiveCustomer

    postData = convertThreePlCustomerDetailToPost({
      ...postData,
    })

    const { url, query } = config.threePlCustomer.create

    try {
      const response = await axios.post(url, {
        query,
        variables: {
          Input: postData,
        },
      })

      if (response) {
        if (setActive) {
          const {
            ID,
            DefaultLocationForSupplier,
            InternalItemID,
            Company,
            EnCity,
            Warehouse,
            Email,
            DeliveryAddress,
            FirstName,
            Is3PL,
            Surname,
          } = response?.data?.data?.createUpdateThreePLCustomer
          let value = {
            label: `(${InternalItemID}) ${Company} - ${EnCity || DeliveryAddress?.State}`,
            original: {
              Company,
              Email,
              EnCity,
              EnEmail: Email,
              EnState: DeliveryAddress?.State,
              FirstName,
              ID,
              DefaultLocationForSupplier,
              InternalItemID,
              Is3PL,
              Surname,
              Warehouse: { ID: Warehouse?.ID, Code: 'default' },
            },
            value: ID,
          }
          // console.log("response from postThreePlCustomer" , response , value);

          if (callback) {
            callback(value)
          }
          // dispatch(updateActive3PLCustomerName(value))
        }
        dispatch(toggleModal(false))
        dispatch(toggleAddCustomerModal(false))
        dispatch(requestThreePlCustomerList())
        // dispatch(requestAllThreePlCustomerList())
        dispatch(emptyCreateCustomerDetails())
        createAlert(
          {
            message: '3PL Customer Successfully Created',
          },
          'success'
        )
      } else {
        createAlert({}, 'error')
      }

      dispatch(toggleLoading('form', false))
    } catch (error) {
      dispatch(toggleLoading('form', false))
      return handleAxiosErrors(error)
    }
  }
}

export const editThreePlCustomer = (postData) => {
  return async (dispatch, getState) => {
    dispatch(toggleLoading('form', true))

    //dispatch(toggleLoading(false));

    postData = convertThreeEditPlCustomerDetailToPost({
      ...postData,
    })

    const { url, query } = config.threePlCustomer.create

    try {
      const response = await axios.post(url, {
        query,
        variables: {
          Input: postData,
        },
      })

      if (response) {
        dispatch(toggleEditModal(false))
        dispatch(requestThreePlCustomerList())
        // dispatch(requestAllThreePlCustomerList())
        createAlert(
          {
            message: '3PL Customer Successfully Updated',
          },
          'success'
        )
      } else {
        createAlert({}, 'error')
      }

      dispatch(toggleLoading('form', false))
    } catch (error) {
      dispatch(toggleLoading('form', false))
      return handleAxiosErrors(error)
    }
  }
}

export const deleteThreePlCustomer = (postData) => {
  return async (dispatch, getState) => {
    const state = getState()

    dispatch(toggleLoading('deleting', true))
    //dispatch(toggleLoading(false));

    postData = convertDeleteThreePlCustomerDetailToPost({
      ...postData,
    })

    const { url, query } = config.threePlCustomer.create

    try {
      const response = await axios.post(url, {
        query,
        variables: {
          Input: postData,
        },
      })

      if (response) {
        //remove customer from redux state before list api response
        const threePlCustomerList = state.threePlCustomers.list || []
        const filteredList = threePlCustomerList?.filter((customer) => customer.id !== postData.ID)

        dispatch(updateThreePlCustomerList(filteredList))
        dispatch(requestThreePlCustomerList())
        // dispatch(requestAllThreePlCustomerList())
        createAlert(
          {
            message: '3PL Customer Successfully Deleted',
          },
          'success'
        )
      } else {
        createAlert({}, 'error')
      }

      // dispatch(toggleLoading('form', false))
    } catch (error) {
      dispatch(toggleLoading('deleting', false))
      return handleAxiosErrors(error)
    }
  }
}

export const requestThreePlCustomerList = (params) => {
  return (dispatch, getState) => {
    const state = getState()

    return axiosThreePlCustomerList(params)
      .then((response) => {
        if (typeof response?.data?.data?.readAllThreePLCustomers.edges != 'undefined') {
          const products = convertThreePlCustomerListingToAReadableFormat(
            response?.data?.data?.readAllThreePLCustomers.edges,
            state.user
          )
          Promise.all([dispatch(updateThreePlCustomerList(products))]).then(() => {
            dispatch(toggleLoading('list', false))
            dispatch(toggleLoading('deleting', false))
          })
        } else {
          dispatch(toggleLoading('list', false))
          dispatch(toggleLoading('deleting', false))
          createAlert({}, 'bad')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading('list', false))
        dispatch(toggleLoading('deleting', false))
        handleAxiosErrors(error)
      })
  }
}

export const requestFilterThreePlCustomerList = (params) => {
  return (dispatch, getState) => {
    const state = getState()

    return axiosFilterThreePlCustomerList(params)
      .then((response) => {
        if (typeof response?.data?.data?.readAllThreePLCustomers.edges != 'undefined') {
          const products = convertThreePlCustomerListingToAReadableFormat(
            response?.data?.data?.readAllThreePLCustomers.edges,
            state.user
          )
          Promise.all([dispatch(updateThreePlCustomerList(products))]).then(() => {
            dispatch(toggleLoading('list', false))
          })
        } else {
          dispatch(toggleLoading('list', false))
          createAlert({}, 'bad')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading('list', false))
        handleAxiosErrors(error)
      })
  }
}

export const requestFilterThreePlCustomerListForFullist = (params) => {
  return (dispatch, getState) => {
    const state = getState()

    return axiosFilterThreePlCustomerListFullist(params)
      .then((response) => {
        if (typeof response?.data?.data?.readAllThreePLCustomers.edges != 'undefined') {
          const customers = convertThreePlCustomerListingToAReadableFormat(
            response?.data?.data?.readAllThreePLCustomers.edges,
            state.user
          )
          Promise.all([dispatch(updateThreePlCustomerFullList(customers))]).then(() => {
            dispatch(toggleLoading('list', false))
          })
        } else {
          dispatch(toggleLoading('list', false))
          createAlert({}, 'bad')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading('list', false))
        handleAxiosErrors(error)
      })
  }
}

export const requestAllThreePlCustomerList = (params) => {
  return (dispatch, getState) => {
    const state = getState()

    return axiosAllThreePlCustomerList(params)
      .then((response) => {
        if (typeof response?.data?.data?.readAllThreePLCustomers.edges != 'undefined') {
          const customers = convertThreePlCustomerListingToAReadableFormat(
            response?.data?.data?.readAllThreePLCustomers.edges,
            state.user
          )
          Promise.all([dispatch(updateThreePlCustomerFullList(customers))]).then(() => {
            dispatch(toggleLoading('fullList', false))
          })
        } else {
          dispatch(toggleLoading('fullList', false))
          createAlert({}, 'bad')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading('fullList', false))
        handleAxiosErrors(error)
      })
  }
}

export const axiosThreePlCustomerList = (params) => {
  let { url, query } = config.threePlCustomer.listing
  let filterParam = {}
  filterParam = {
    filters: {
      q: params?.search,
      // IsActivatedOnly: true,
    },
  }
  return axios.get(url, {
    params: {
      query: query,
      variables: filterParam,
    },
  })
}

export const axiosFilterThreePlCustomerList = (params) => {
  let { url, query } = config.threePlCustomer.listing
  let filterParam = {}
  filterParam = {
    filters: {
      // IsActivatedOnly: true,
      // ThreePLCustomerType: params?.containerType || '',
      State: params?.stateList || '',
    },
  }
  return axios.get(url, {
    params: {
      query: query,
      variables: filterParam,
    },
  })
}

export const axiosFilterThreePlCustomerListFullist = (params) => {
  let { url, query } = config.threePlCustomer.listing
  let filterParam = {}
  filterParam = {
    filters: {
      // IsActivatedOnly: false,
      q: params?.search,
      // ThreePLCustomerType: params?.containerType || '',
      State: params?.stateList || '',
    },
  }
  return axios.get(url, {
    params: {
      query: query,
      variables: filterParam,
    },
  })
}

export const axiosAllThreePlCustomerList = (params) => {
  let { url, query } = config.threePlCustomer.listing
  let filterParam = {}
  filterParam = {
    filters: {
      q: params?.search,
      // IsActivatedOnly: false,
    },
  }
  return axios.get(url, {
    params: {
      query: query,
      variables: filterParam,
    },
  })
}

export const activateThreePlCustomer = (params) => {
  return (dispatch, getState) => {
    let { url, query } = config.threePlCustomer.toggleActivateCustomer

    return axios
      .post(url, {
        query: query,
        variables: {
          CustomerID: parseInt(params.id),
        },
      })
      .then((response) => {
        console.log(response)
        if (response.data.data.toggleActivateThreePLCustomer) {
          console.log(response.data.data.toggleActivateThreePLCustomer.IsActivated)
          if (response.data.data.toggleActivateThreePLCustomer.IsActivated) {
            createAlert({ message: 'Customer Activated' }, 'success')
          } else {
            createAlert({ message: 'Customer Deactivated' }, 'success')
          }
          dispatch(requestThreePlCustomerList(params))
          // dispatch(requestAllThreePlCustomerList(params))
          return true
        }
        createAlert({}, 'error')
        return false
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const requestCreditTermsOptions = () => {
  return (dispatch, getState) => {
    let { url, query } = config.threePlCustomer.readCreditTermsOptions

    return axios
      .post(url, {
        query: query,
      })
      .then((response) => {
        if (response.data?.data?.readGlobalConfig?.CreditTermsOptions) {
          dispatch(setCreditTermsOptions(response.data.data.readGlobalConfig.CreditTermsOptions))
          return true
        }
        createAlert({}, 'error')
        return false
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const setCreditTermsOptions = (creditTerms) => {
  creditTerms = [
    {
      Terms: 'Select Credit Term',
      TermID: '',
    },
    ...creditTerms,
  ]
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_GOLBAL_CONFIG_CREDIT_TERMS',
      value: creditTerms,
    })
  }
}

export const threePlHandleGoogleAddressChecker = (address) => {
  return (dispatch, getState) => {
    const streetNumber = getAddressComponent('street_number', address?.address_components || '')
    const streetName = getAddressComponent('route', address?.address_components || '')
    const postalCode = getAddressComponent('postal_code', address?.address_components || '')
    const suburb = getAddressComponent('locality', address?.address_components || '')
    const state = getAddressComponent('administrative_area_level_1', address?.address_components || '', 'short_name')
    const unitNumber = getAddressComponent('subpremise', address?.address_components || '')
    dispatch(changeThreePlCustomerAddDetails('streetNumber', streetNumber))
    dispatch(changeThreePlCustomerAddDetails('streetName', streetName))
    dispatch(changeThreePlCustomerAddDetails('postalCode', postalCode))
    dispatch(changeThreePlCustomerAddDetails('suburb', suburb))
    dispatch(changeThreePlCustomerAddDetails('state', state))
    dispatch(changeThreePlCustomerAddDetails('address', address?.formatted_address || ''))
    dispatch(changeThreePlCustomerAddDetails('unitNumber', unitNumber))
  }
}

export const toggleParamountCustomer = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PARAMOUNT_CUSTOMER',
      value: value,
    })
  }
}

export const getAddressComponent = (key, addressComponents, value = 'long_name') => {
  let data = ''
  addressComponents.length > 0 &&
    addressComponents.forEach((address) => {
      if (address?.types && address.types.includes(key)) {
        data = address[value]
      }
    })
  return data
}
